/**
 * Los 13 tipos del ledger, en el orden de `PerronPoint::TYPES` de la API (D4 de `perron-coins-plan.md`). Los 9 de
 * Perrón Coins aún no tienen escritor: llegan con las addendas de cada madre.
 */
export const PERRON_POINTS_ENTRY_TYPES = [
  'purchase_accrual',
  'purchase_reversal',
  'code_redemption',
  'code_reversal',
  'raffle_entry',
  'raffle_refund',
  'opportunity_purchase',
  'coin_payment',
  'coin_payment_refund',
  'campaign_bonus',
  'collaboration_bonus',
  'referral_bonus',
  'birthday_bonus',
] as const;

export type PerronPointsEntryType = (typeof PERRON_POINTS_ENTRY_TYPES)[number];

/** Entrada del ledger `perron_points` (paginada, ver `PerronPointsSummary.entries`). */
export interface PerronPointsEntry {
  id: number;
  /** Con signo: los débitos ya llegan en negativo. */
  amount: number;
  type: PerronPointsEntryType;
  preorder_id: number | null;
  created_at: string;
}

/** Respuesta de `GET /perron-points/me`. */
export interface PerronPointsSummary {
  balance: number;
  early_access: boolean;
  threshold: number;
  entries: {
    data: PerronPointsEntry[];
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
  };
}

/**
 * `GET /perron-points/me` con las dos claves aditivas de Perrón Coins (D6, M-JSON-2). Va aparte para no obligar a
 * los specs que construyen `PerronPointsSummary` a mano a añadirlas.
 */
export interface PerronCoinsMeSummary extends PerronPointsSummary {
  lifetime_earned: number;
  coin_value_crc: number;
}

/** Respuesta 200 de `POST /perron-points/redeem`. */
export interface PerronPointsRedeemResponse {
  points: number;
  balance: number;
}

export type PerronPointsErrorReason = 'invalid' | 'consumed' | 'throttled' | 'unknown';

export class PerronPointsError extends Error {
  constructor(
    public readonly reason: PerronPointsErrorReason,
    message: string,
  ) {
    super(message);
    this.name = 'PerronPointsError';
  }
}
